import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

// Keuzelijst met het gewone <select> van de browser, in de stijl van Input. Bewust geen
// Radix-Select: lange lijsten (alle panden, contacten) zijn zo op gsm en met het toetsenbord
// het makkelijkst, en `multiple` werkt ook.
const NativeSelect = React.forwardRef<HTMLSelectElement, React.ComponentProps<"select">>(({ className, multiple, ...props }, ref) => (
  <div className="relative">
    <select
      ref={ref}
      multiple={multiple}
      className={cn(
        "w-full rounded-[10px] border border-input bg-white px-3 text-[13px] shadow-sm transition-colors focus-visible:border-navy-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 disabled:cursor-not-allowed disabled:opacity-50",
        multiple ? "py-1.5" : "h-[38px] appearance-none pr-8",
        className
      )}
      {...props}
    />
    {!multiple && <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />}
  </div>
));
NativeSelect.displayName = "NativeSelect";

export { NativeSelect };
